import React from 'react';
import ReactDOM from 'react-dom';
import './styles/reset.css';
import './styles/styles.css';
import './styles/toast.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import store from './redux/store';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import Raven from 'raven-js';
import loadPolyfills from './lib/loadPolyfills';

//configure sentry if not in production
if (process.env.NODE_ENV !== 'development') {
    Raven.config('https://140870c8654346f58963383942f1cc83@sentry.io/1197093').install();
}

loadPolyfills();

ReactDOM.render(
    <Provider store={store}>
        <div>
            <App />
            <ReduxToastr
                timeOut={6000}
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar
            />
        </div>
    </Provider>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js